import { render } from "./B2C.vue?vue&type=template&id=2a622be8&lang=pug"
import script from "./B2C.vue?vue&type=script&setup=true&lang=js"
export * from "./B2C.vue?vue&type=script&setup=true&lang=js"

import "./B2C.vue?vue&type=style&index=0&id=2a622be8&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__